// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__3V9-P","modal":"Modal_modal__XspBU"};